import React from 'react'
import Landing from './Landing'


const App = () => {
	return (
		<Landing />
	)
}

export default App
